import React from 'react';
import {useTranslation} from 'react-i18next';

import DeviceRegistrationErrorPopup from './DeviceRegistrationErrorPopup';

type Props = {
  visible: boolean;
  logout: () => void;
  register: () => void;
};

const DeviceRegistrationFailedPopup: React.FunctionComponent<Props> = props => {
  const {t} = useTranslation();
  return (
    <DeviceRegistrationErrorPopup
      title={t('deviceRegistrationFailedPopup.title')}
      message={t('deviceRegistrationFailedPopup.message')}
      actionButtonMessage={t('deviceRegistrationFailedPopup.registerButton')}
      action={props.register}
      {...props}
    />
  );
};

export default React.memo(DeviceRegistrationFailedPopup);
